import { HER_FOOTER_ACTIONS } from '../../actions/herFooterActions';

const footerReducer = (state = {
  infoItems: null
}, action) => {
  switch (action.type) {
    case HER_FOOTER_ACTIONS.FETCH_DATA:
      state = {
        ...state,
        infoItems: action.payload
      }
      break;
    default:
      break;
  }
  return state;
};

export default footerReducer;
